var snapchatSubmitForm = function (form) {
  var elements = form.elements, check = false;
  for (var i = 0, element; element = elements[i++];) {
    if (element.value == "" && element.name!="performer_custom_snapchat_subscription") {
      console.log($(element).closest(".row"));
      $(element).closest(".row").addClass("alert");
      check = true;
    }
  }
  if (!check) form.submit();
};

(function () {
  var allData;
  var data;
  var recuringHref;
  var limitedHref;
  var performerId;
  var customerSnapchatId;
  var swalInstance;

  $(document).on('snapchatFillData', function (event, dataObject) {
    allData = dataObject;
  });

  $(document).on('showSnapchatSubscription', function (event, id) {
    var el = event.target.activeElement;
    if (el.classList.contains("profile") && el.tagName.toLowerCase() === "a") return;
    data = allData[""+id+""];
    recuringHref = data.exec+'/addfunds?package_id='+data.packageRecuringId+'&performer_id='+data.performerId;
    limitedHref = data.exec+'/addfunds?package_id='+data.packageLimitedId+'&performer_id='+data.performerId;
    performerId = data.performerId;
    customerSnapchatId = data.customerSnapchatId;

    var description = "";
    description += data.desc.trim() != "" ? data.desc.trim() + ". " :  "";
    description += "<br>";
    description += data.snapchatUpdateRate.trim() != "" ? I18n.t("Updates")+" " + data.snapchatUpdateRate.trim() + " times per week. " :  "";
    description += "<br>";
    description += data.snapchatRaiting != "" ? I18n.t("Content rating")+" : " +  data.snapchatRaiting.trim() + ". " :  "";
    description += "<br>";

    var priceMonth = parseFloat(data.priceMont);
    var pricePerMonth = parseFloat(data.pricerPerMonth);
    priceMonth += priceMonth % 1 == 0.5 ? "0" : "";
    pricePerMonth += pricePerMonth % 1 == 0.5 ? "0" : "";

    description = description != "" ? description : I18n.t("Get instant access to the Premium Snapchat account of {1} now!",[data.performerScreenName]);
    var html = "<div class='description'>"+ description;
    html += "<input type='text' class='swal2-input snapchatId' placeholder='"+I18n.t("Your Snapchat ID")+"' value='"+data.customerSnapchatId+"'>";
    html += "<div class='button-set'>";
    var descriptionDuration = I18n.t("Your account credit balance will be debited the above amount for access until {1}", [data.subscriptionTime]);
    // html += "<div class='button-row'><span>"+I18n.t("Your credit card will be charged the above amount every 30 days",[pricePerMonth])+"</span><button class='swal2-styled buy subscription'>"+I18n.t("Buy for ${1}",[pricePerMonth])+"</button></div>";
    // html += "<div class='button-row'><span>"+I18n.t("Your credit card will be charged the above amount once for 30 day access.",[priceMonth])+"</span><button class='swal2-styled buy month'>"+I18n.t("Buy for ${1}",[priceMonth])+"</button></div>";
    html += "<div class='button-row'><span>"+descriptionDuration+"</span><button class='swal2-styled btn btn-primary buy credits'>"+I18n.t("Buy for {1}CR",[priceMonth])+"</button></div>";
    html += "</div>";
    swalInstance = swal({
      title: I18n.t("{1}'s Snapchat", [data.performerScreenName]),
      html: html,
      width: 700,
      background: "transparent",
      showCancelButton: true,
      showConfirmButton: false,
    });

    $(".swal2-styled.buy").on("click", function() {
      var customerSnapchatId = $(".swal2-container .snapchatId").val();
      var callSwal = function(text, type) {
        swal({
          text: text,
          background: "transparent",
          confirmButtonColor: "#FC0",
          type: type
        });
      }
      var error = function() {
        callSwal(I18n.t("An error occurred. Please try again."), "error");
      }

      if ($(this).hasClass("subscription")) window.location = recuringHref;
      else if ($(this).hasClass("month")) window.location = limitedHref;
      else if ($(this).hasClass("credits")) {
        swal.showLoading();
        $(".swal2-container .button-set").hide();
        $(".swal2-container .snapchatId").hide();
        $(".swal2-container .swal2-cancel").hide();
        if (customerSnapchatId == "") {
          callSwal(I18n.t("For subscribe you need to fulfill Snapchat username field"), "error");
          return;
        } else if (performerId == "") error();

        $.ajax({
          type: "POST",
          url:  data.exec+'/_snapchatSubscriptionsFromAccount.jsp',
          data: {
            'performerId' : performerId,
            'snapchat_id' : customerSnapchatId
          },
          success: function (response) {
            response = response.replace(/^\s+|\s+$/g, '');
            switch (response) {
              case 'true':
                callSwal(I18n.t("Success. Enjoy this model's Snapchat."), "success");
                break;
              case 'error':
                error();
                break;
              case 'exist':
                callSwal(I18n.t("You have already subscribed to this snapchat."), "info")
                break;
              case 'false':
                callSwal(I18n.t("Your account does not include sufficient funds to complete this transaction. Choose another option."), "info")
                break;
            };
          },
          error: function(){error()}
        });
      } else swal.close();
    });
  });
})();